import {InitialRequestUrl} from "@khan/shared-core";

import {HostnameParts} from "./hostname-parts.ts";

/**
 * Returns the classroom URL for the current environment. The returned string
 * DOES NOT contain a trailing slash. Callers adding a path part should
 * include an initial slash, e.g. /learner.
 *
 * @returns {string} The classroom URL
 */
export const getClassroomUrl = (): string => {
    const currentHostname = InitialRequestUrl.hostname;
    const hostnameParts = HostnameParts.parse(currentHostname);

    // If we can't parse the hostname, fall back to the default
    if (!hostnameParts.baseDomain) {
        return "https://classroom.khanacademy.org";
    }

    // We use lang on HostnameParts to swap the subdomain. Note that lang in
    // this context is a misnomer -- it's the subdomain part of the hostname,
    // which is used to indicate the language on classic Khan, e.g.
    // en.khanacademy.org. But other subdomains, like classroom, follow the same
    // URL construction rules.
    hostnameParts.lang = "classroom";

    const classroomDomain = hostnameParts.domain();

    // If we can't construct a valid domain, fall back to the default
    if (!classroomDomain) {
        return "https://classroom.khanacademy.org";
    }

    // Use the same protocol -- we're just changing to the classroom subdomain
    // (however that needs to be done).
    return `${InitialRequestUrl.protocol}//${classroomDomain}`;
};
